import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { Provider, useAtomValue, useSetAtom } from "jotai";
import { View } from "tamagui";
import { User } from "@supabase/supabase-js";
import { currentUserAtom } from "../../atoms/global";
import { useEffect } from "react";
import { CreateRideForm } from "../screens/CreateRide";
import { RouteSelect } from "../screens/CreateRide/RouteSelect/RouteSelect";

export type RidesNavigatorParamList = {
  RouteSelect: undefined;
  Location: undefined;
  Visibility: undefined;
  RideInformation: undefined;
  Share: { eventId: string };
  Invites: undefined;
};

const Stack = createNativeStackNavigator<RidesNavigatorParamList>();

export const CreateARideNavigator = () => {
  const currentUser = useAtomValue(currentUserAtom);
  return (
    <View flex={1}>
      <Provider>
        <CreateARideAtomHydrator user={currentUser} />
        <View flex={1}>
          <Stack.Navigator
            screenOptions={{ headerShown: false, title: "CreateARide" }}
          >
            <Stack.Screen name="RouteSelect" component={RouteSelect} />
            <Stack.Screen name="RideInformation" component={CreateRideForm} />
          </Stack.Navigator>
        </View>
      </Provider>
    </View>
  );
};

const CreateARideAtomHydrator = ({ user }: { user: User | null }) => {
  const setCurrentUser = useSetAtom(currentUserAtom);

  useEffect(() => {
    if (user) {
      setCurrentUser(user);
    }
  }, [user]);
  return null;
};
